module.exports = __webpack_public_path__ + "static/media/location_icon.71d708f7.svg";